<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button id="confirm-btn-loading" size="small" :textButton="confirmReturn ? $t('confirm to return') : $t('Confirm to Ship')"
        :iconStyle="{LeftIconName: 'TruckIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" @click="requestPickup()" class="vs-con-loading__container w-full"/>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select the order you want to ship!')}`">
        <shipblu-button size="small" :textButton="confirmReturn ? $t('confirm to return') : $t('Confirm to Ship')"
        :iconStyle="{LeftIconName: 'TruckIcon', LeftIconLibrary: 'feather', iconPosition: 'left'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import { sendFulfillmentRequest } from '../../../../http/axios/requestHelper.js'
import { common } from '../../../admin/Orders.vue'
export default {
  props: ['selected', 'confirmReturn'],
  data () {
    return {
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0 && val.filter(item => item.status === 'created').length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    requestPickup () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#confirm-btn-loading',
        scale: 0.45
      })
      const trackings = []
      let url = ''
      this.selected.forEach(element => {
        if (this.$route.name === 'merchant-fulfillment-outbound-orders' && (element.status === 'created' || element.status === 'confirmed_to_return')) {
          url = `api/v1/fc/orders/${this.selected[0].id}/tracking/`
          trackings.push({
            order:element.id,
            status: 'confirmed_to_ship'
          })
        } else if (this.$route.name === 'merchant-fulfillment-inbound-orders') {
          url = `api/v1/fc/orders/${this.selected[0].id}/tracking/`
          trackings.push({
            order:element.id,
            status: 'confirmed_to_return'
          })
        }
      })
      sendFulfillmentRequest(true, false, this, url, 'post', trackings, true,
        () => {
          this.$emit('loadShipments')
          this.$emit('selected', [])
          this.$vs.loading.close('#confirm-btn-loading > .con-vs-loading')
        }, (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#confirm-btn-loading > .con-vs-loading')
        }
      )
    }
  }
}
</script>